import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ReleaseStatusOptions } from "../constants/form-constants";
import { FormGroup, Select, Label } from "../../../components/atoms/Form";

const ReleaseStatus = (props) => {
  const { onChange, releaseStatus } = props;

  const onChangeReleaseStatus = (e) => {
    onChange(e.target.value, "releaseStatus");
  };

  useEffect(() => {
    onChange(releaseStatus, "releaseStatus");
  }, [releaseStatus]);

  return (
    <FormGroup className="tw-flex tw-w-6/12">
      <Label text="Release Status" />
      <Select
        type="select"
        name="releaseStatus"
        onChange={(event) => onChangeReleaseStatus(event)}
        value={releaseStatus}
      >
        <option value="" />
        {ReleaseStatusOptions.map((value, index) => (
          <option key={`${index}-release-status-${value}`} value={value}>
            {value}
          </option>
        ))}
      </Select>
    </FormGroup>
  );
};

ReleaseStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  releaseStatus: PropTypes.string,
};

ReleaseStatus.defaultProps = {
  releaseStatus: "",
};
export default ReleaseStatus;
